import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import { connect } from 'react-redux'
import { actions } from 'react-redux-form'

import { UI } from 'components/_Assets/svg/Icon/ui'
import { Modal, ModalFooter, ModalHeader } from 'components/Modal'
import { refreshCurrentTotal } from '../../data/api/order'
import { AppState } from '../../data/state'

interface PriceErrorProps {
  priceError: any | undefined
  dismissPriceError: () => void
  removeDiscountCode: () => void
}

class PriceErrorModal extends React.Component<PriceErrorProps> {
  public render() {
    return this.props.priceError ? (
      <Modal color={false}>
        <ModalHeader icon={UI.warning}>
          <DisplayContent contentKey="price-error">
            Error getting price
          </DisplayContent>
        </ModalHeader>
        <div className="content">
          {Object.entries(this.props.priceError).map((x: [string, any]) => {
            const [code, message] = x
            return (
              <div key={code}>
                <strong>{code.toUpperCase()}:</strong>
                <br />
                <span>{message}</span>
                <br />
              </div>
            )
          })}
        </div>
        <ModalFooter
          hideClose
          onClose={this.dismiss}
          onSave={this.dismiss}
          saveText={<DisplayContent contentKey="ok">OK</DisplayContent>}
        />
      </Modal>
    ) : null
  }

  private dismiss = () => {
    this.props.dismissPriceError()
    if (this.props.priceError.hasOwnProperty('discount_code')) {
      this.props.removeDiscountCode()
      refreshCurrentTotal()
    }
  }
}

export default connect(
  (state: AppState) => ({
    priceError: state.ui.priceError,
  }),
  dispatch => ({
    dismissPriceError: () => {
      dispatch(actions.change('ui.priceError', undefined))
    },
    removeDiscountCode: () => {
      dispatch(actions.change('funnelOrder.discountCode', null))
    },
  }),
)(PriceErrorModal)
